module.exports = __webpack_public_path__ + "static/ceo-tim-gerend.ed1bef63.webp";